import { ThemeUICSSObject } from '@apia/theme';

const infoTooltip: ThemeUICSSObject = {
  '&.infoTooltip': {
    position: 'absolute',
    bottom: '7%',
    background: 'moccasin',
    padding: 4,
    maxWidth: '40vh',
    transform: 'translateY(0px)',
    transition: 'transform 0.2s, opacity 0.5s',
    opacity: 0,
    boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
  },
  '&.infoTooltip.in.visible': {
    opacity: 1,
    transform: 'translateY(-10px)',
  },
};

export default infoTooltip;
